import React from 'react';
import {Matches} from './blocks';
import {MatchDetailsData} from "@/pages/buddy/types/MatchDetailsData.ts";

interface MatchesContentProps {
    matches: MatchDetailsData[];
    loading: boolean;
    on_delete: (companyId: string) => void; // Add the on_delete prop
}

const MatchesContent: React.FC<MatchesContentProps> = ({
                                                           matches,
                                                           loading,
                                                           on_delete, // Pass down the on_delete prop
                                                       }) => {
    return (
        <div>
            <Matches
                matches={matches}
                loading={loading}
                on_delete={on_delete} // Pass the on_delete prop to Matches
            />
        </div>
    );
};

export {MatchesContent};
